var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"course-listing-section"},[_c('b-container',[_c('div',{staticClass:"d-flex"},[(_vm.showHeading)?_c('h4',{staticClass:"title text-left"},[_vm._v("\n        Popular "+_vm._s(_vm.course_name)+" Courses\n      ")]):_vm._e(),(_vm.showHeading)?_c('p',{staticClass:"see-all"},[_c('b-link',{attrs:{"to":{
            path: '/all_courses',
            query: {
              course_name: _vm.course_name,
              category_id: _vm.categoryId
            }
          }}},[_vm._v("See All\n        ")])],1):_vm._e()]),_c('b-row',_vm._l((_vm.course_count),function(i){return _c('b-col',{key:'course' + i,attrs:{"cols":"12","md":"6","lg":"3"}},[(_vm.courseArray.length > 0)?_c('course-template',{attrs:{"courseData":_vm.courseArray[i - 1]}}):_c('ContentLoader',{attrs:{"height":450}})],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }